import { CommonNS } from "../../../../Common/CommonNS.js";
import { ControllerNS } from "../../Controller/ControllerNS.js";
import { VONS } from "../../VO/VONS.js";
export class ArtBoardView {
  constructor({
    art_board_controller,
    art_board_rect_el,
    art_board_filter_drop_shadow_el,
  }) {
    this._art_board_rect_el = art_board_rect_el;
    this._art_board_filter_drop_shadow_el = art_board_filter_drop_shadow_el;
    art_board_controller.subscribe((vo) => this._observeArtBoardController(vo));
  }
  _observeArtBoardController({ width, height }) {
    const unit = Math.round((height / 400) * 100) / 100;
    CommonNS.UtilNS.tryNoop(() =>
      this._art_board_rect_el.setAttributeNS(null, "width", `${width}`)
    );
    CommonNS.UtilNS.tryNoop(() =>
      this._art_board_rect_el.setAttributeNS(null, "height", `${height}`)
    );
    CommonNS.UtilNS.tryNoop(() =>
      this._art_board_rect_el.setAttributeNS(null, "stroke-width", `${unit}`)
    );
    CommonNS.UtilNS.tryNoop(() =>
      this._art_board_filter_drop_shadow_el.setAttributeNS(
        null,
        "dy",
        `${unit}`
      )
    );
    CommonNS.UtilNS.tryNoop(() =>
      this._art_board_filter_drop_shadow_el.setAttributeNS(
        null,
        "stdDeviation",
        `${unit * 2}`
      )
    );
  }
}
